import store from '../../store';


const hasNotUniqueFieldSetName = (name, initialValues = {}) => {
  const { fieldSets } = store.getState();
  return initialValues.name !== name && fieldSets.some(fieldSet => name === fieldSet.name);
};

// props.initialValues: initial values of the form (passed by reduxForm).
const validate = (values, props = {}) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Обязательное поле';
  } else if (hasNotUniqueFieldSetName(values.name, props.initialValues)) {
    errors.name = 'Набор полей с таким именем уже существует';
  }
  if (values.fields) {
    const errorFields = [];
    values.fields.forEach((field) => {
      if (!field.field_id) {
        errorFields.push({ field_id: 'Выберите поле' });
      } else {
        errorFields.push(null);
      }
    });
    errors.fields = errorFields;
  }
  return errors;
};

export default validate;
